import './restrictions.service'
;(function () {
  'use strict'

  angular
    .module('admin.users.details.restrictions', ['admin.users.details.restrictions.service'])
    .controller('RestrictionsAdminCtrl', RestrictionsAdminCtrl)

  /** @ngInject */
  function RestrictionsAdminCtrl($scope, $stateParams, UsersService, RestrictionsService) {
    var vm = this
    vm.items = []
    vm.userId = $stateParams.parentId

    load()

    function load() {
      UsersService.listRestrictions($stateParams.parentId).then(success)

      function success(result) {
        vm.items = result.results
      }
    }

    vm.toggle = function (key, value) {
      RestrictionsService.update(vm.userId, { [key]: !value }).then(function () {
        load()
      })
    }
  }
})()
